import { render, staticRenderFns } from "./IssuesTypesList.vue?vue&type=template&id=79df7dda"
import script from "./IssuesTypesList.vue?vue&type=script&lang=js"
export * from "./IssuesTypesList.vue?vue&type=script&lang=js"
import style0 from "./IssuesTypesList.vue?vue&type=style&index=0&id=79df7dda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports